import React, { useState } from 'react';
import { Card } from 'antd';
import { useRoleGuard } from 'shared/hooks/use-role-guard';
import { UserRole } from 'types/user';
import { ClientOrders } from 'components/clients/client-orders';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { ExpensesListWithCreateButton } from 'components/expenses/expenses-list-with-create-button';

interface IClientMainProps {
  clientId: number;
}

export const ClientMain: React.FC<IClientMainProps> = (props) => {
  const { clientId } = props;
  const [activeTabKey, setActiveTabKey] = useState<string>('orders');
  const isExpensesTabVisible = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.accountant]);

  const onTabChange = (key: string) => {
    setActiveTabKey(key);
  };

  const tabListNoTitle = [
    {
      key: 'orders',
      label: 'Orders',
    },
    {
      key: 'documents',
      label: 'Documents',
    },
    ...(isExpensesTabVisible
      ? [
          {
            key: 'expenses',
            label: 'Expenses',
          },
        ]
      : []),
  ];

  const contentListNoTitle: Record<string, React.ReactNode> = {
    orders: <ClientOrders clientId={clientId} />,
    documents: (
      <>
        <DocumentsUpload clientId={clientId} />
        <DocumentsList clientId={clientId} />
      </>
    ),
    expenses: isExpensesTabVisible ? <ExpensesListWithCreateButton clientId={clientId} /> : null,
  };

  return (
    <Card
      style={{ width: '100%' }}
      tabList={tabListNoTitle}
      activeTabKey={activeTabKey}
      // tabBarExtraContent={<a href='#'>More</a>}
      onTabChange={onTabChange}>
      {contentListNoTitle[activeTabKey]}
    </Card>
  );
};
